// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__lpprq","info":"UpdateTermsInfo_info__1_PJS"};